import { createSlice } from '@reduxjs/toolkit'
import { User } from './user.def.ts'
import { UserInfo } from '../../apis/auth/auth.def.ts'
import { RootState } from '../../redux/store.ts'

const initialState: User = {
  accessToken: '',
  userInfo: null as unknown as UserInfo,
  loading: false,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAccessToken: (state, action) => {
      state.accessToken = action.payload
    },
    requestUserInfo: (state) => {
      state.loading = true
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload
      state.loading = false
    },
  },
})

export const selectUser = (state: RootState) => state.user.userInfo as UserInfo

export const { setAccessToken, setUserInfo, requestUserInfo } =
  userSlice.actions

export default userSlice.reducer
